<div class="media-viewer-container">
  <!-- Toolbar -->
  <mat-toolbar class="media-toolbar">
    <button mat-icon-button (click)="goBack()" class="back-button">
      <i-tabler name="arrow-left"></i-tabler>
    </button>

    <span class="file-name">{{ fileName }}</span>

    <span class="spacer"></span>

    <button mat-icon-button (click)="downloadFile()" *ngIf="fileUrl || safeUrl" class="download-button">
      <i-tabler name="download"></i-tabler>
    </button>
  </mat-toolbar>

  <!-- Loading Indicator -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Dosya yükleniyor...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="error" class="error-container">
    <i-tabler name="alert-circle" class="error-icon"></i-tabler>
    <p>{{ error }}</p>
  </div>

  <!-- Content Area -->
  <div class="content-area" *ngIf="!isLoading && !error">

    <!-- Text Files -->
    <div *ngIf="fileType === 'text'" class="text-viewer">
      <div *ngIf="isLoading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Dosya içeriği yükleniyor...</p>
      </div>
      <div *ngIf="!isLoading && error" class="error-container">
        <i-tabler name="alert-circle" class="error-icon"></i-tabler>
        <p>{{ error }}</p>
      </div>
      <pre *ngIf="!isLoading && !error" [innerHTML]="fileContent"></pre>
    </div>

    <!-- Image Files -->
    <div *ngIf="fileType === 'image'" class="image-viewer">
      <!-- Loading indicator for images -->
      <div *ngIf="!imageLoaded && !error" class="image-loading">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Resim yükleniyor...</p>
      </div>

      <div class="image-container" #imageContainer *ngIf="imageLoaded">
        <img
          [src]="safeUrl"
          [alt]="fileName"
          #imageElement
          (load)="onImageLoad()"
          (error)="onImageError()"
          (wheel)="onImageWheel($event)"
          (mousedown)="onImageMouseDown($event)"
          (mousemove)="onImageMouseMove($event)"
          (mouseup)="onImageMouseUp($event)"
          (mouseleave)="onImageMouseUp($event)"
          [style.transform]="'scale(' + imageZoom + ') translate(' + imagePanX + 'px, ' + imagePanY + 'px)'"
          [style.cursor]="isDragging ? 'grabbing' : 'grab'"
          crossorigin="anonymous"
        />
      </div>

      <!-- Zoom Controls -->
      <div class="zoom-controls" *ngIf="imageLoaded">
        <button
          mat-icon-button
          (click)="zoomIn()"
          [disabled]="imageZoom >= 5"
          class="zoom-btn"
          title="Yakınlaştır">
          <i-tabler name="zoom-in"></i-tabler>
        </button>

        <span class="zoom-level">{{ (imageZoom * 100).toFixed(0) }}%</span>

        <button
          mat-icon-button
          (click)="zoomOut()"
          [disabled]="imageZoom <= 0.5"
          class="zoom-btn"
          title="Uzaklaştır">
          <i-tabler name="zoom-out"></i-tabler>
        </button>

        <button
          mat-icon-button
          (click)="resetZoom()"
          class="zoom-btn"
          title="Sıfırla">
          <i-tabler name="refresh"></i-tabler>
        </button>
      </div>
    </div>

    <!-- Video Files -->
    <div *ngIf="fileType === 'video'" class="video-viewer">
      <video
        controls
        [src]="safeUrl"
        controlsList="nodownload"
        oncontextmenu="return false;">
        Tarayıcınız video oynatmayı desteklemiyor.
      </video>
    </div>

    <!-- PDF Files -->
    <div *ngIf="fileType === 'pdf'" class="pdf-viewer">
      <div class="pdf-container">
        <iframe
          [src]="safeUrl"
          frameborder="0"
          type="application/pdf"
          width="100%"
          height="100%"
          (contextmenu)="$event.preventDefault()"
          (selectstart)="$event.preventDefault()"
          (dragstart)="$event.preventDefault()">
          PDF görüntülenemiyor. <a [href]="fileUrl || safeUrl" target="_blank">Buraya tıklayarak açın</a>
        </iframe>
      </div>
    </div>

    <!-- Excel/CSV Files -->
    <div *ngIf="fileType === 'excel'" class="excel-viewer">
      <!-- Loading during sheet change -->
      <div *ngIf="isLoading" class="sheet-loading-overlay">
        <div class="sheet-loading-content">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Excel dosyası işleniyor...</p>
          <p class="loading-details">Büyük dosyalar için bu işlem biraz zaman alabilir</p>
        </div>
      </div>

      <div *ngIf="excelSheets && excelSheets.length > 0" class="excel-content" [class.loading]="isLoading">
        <!-- Sheet Tabs -->
        <mat-tab-group
          *ngIf="excelSheets.length > 1"
          (selectedTabChange)="onSheetChange($event)"
          [selectedIndex]="selectedSheetIndex"
          class="excel-tabs"
          [class.disabled]="isLoading"
          animationDuration="0ms">
          <mat-tab *ngFor="let sheet of excelSheets; let i = index" [label]="sheet">
            <ng-template matTabContent>
              <!-- Tab içeriği lazy loading için boş -->
            </ng-template>
          </mat-tab>
        </mat-tab-group>

        <!-- Sheet Info -->
        <div class="sheet-info" *ngIf="!isLoading && excelSheets.length > 0">
          <span class="current-sheet" *ngIf="excelSheets.length > 1">
            Aktif Sayfa: <strong>{{ excelSheets[selectedSheetIndex] }}</strong>
            ({{ selectedSheetIndex + 1 }} / {{ excelSheets.length }})
          </span>
          <span class="current-sheet" *ngIf="excelSheets.length === 1">
            Sayfa: <strong>{{ excelSheets[selectedSheetIndex] }}</strong>
          </span>
          <span class="data-info" *ngIf="excelData && excelData.length > 0">
            - {{ excelData.length }} satır, {{ excelColumns.length }} kolon
          </span>
        </div>

        <!-- Excel Table -->
        <div class="excel-table-container" *ngIf="excelData && excelData.length > 0 && excelColumns && excelColumns.length > 0 && !isLoading">
          <table mat-table [dataSource]="excelData" class="excel-table mat-elevation-0">
            <!-- Dynamic Columns -->
            <ng-container *ngFor="let column of excelColumns" [matColumnDef]="column">
              <th mat-header-cell *matHeaderCellDef [title]="column">{{ column }}</th>
              <td mat-cell *matCellDef="let element" [title]="element[column]">
                <span [innerHTML]="element[column] || '&nbsp;'"></span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="excelColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: excelColumns;"></tr>
          </table>
        </div>

        <!-- Empty Sheet Message -->
        <div *ngIf="(!excelData || excelData.length === 0) && (!excelColumns || excelColumns.length === 0) && !isLoading" class="empty-sheet">
          <i-tabler name="file-spreadsheet" class="empty-icon"></i-tabler>
          <h4>Bu sayfa boş veya okunamıyor</h4>
          <p>{{ excelSheets[selectedSheetIndex] }} sayfasında görüntülenecek veri bulunmuyor.</p>
          <p class="empty-details">İlk 20 satır boş olan sayfalar otomatik olarak atlanır.</p>
        </div>
      </div>

      <!-- Loading or Error State -->
      <div *ngIf="!excelSheets || excelSheets.length === 0" class="excel-placeholder">
        <i-tabler name="file-spreadsheet" class="excel-icon"></i-tabler>
        <h3>{{ fileName }}</h3>
        <p>Excel dosyası yükleniyor veya işlenemiyor.</p>
        <p class="file-size-info">Büyük dosyalar (2MB+) için işlem süresi uzun olabilir.</p>
      </div>
    </div>

    <!-- Unsupported Files -->
    <div *ngIf="fileType === 'unsupported'" class="unsupported-viewer">
      <div class="unsupported-placeholder">
        <i-tabler name="file-unknown" class="unsupported-icon"></i-tabler>
        <h3>Bu dosya türü desteklenmiyor</h3>
        <p>Seçilen dosya formatı görüntülenemiyor.</p>
        <button mat-raised-button color="primary" (click)="downloadFile()" *ngIf="fileUrl || safeUrl">
          <i-tabler name="download"></i-tabler>
          Dosyayı İndir
        </button>
      </div>
    </div>

    <!-- No File Selected -->
    <div *ngIf="!fileUrl && !fileName" class="no-file-container">
      <div class="no-file-placeholder">
        <i-tabler name="file-plus" class="no-file-icon"></i-tabler>
      </div>
    </div>

  </div>
</div>
